module.exports = __webpack_public_path__ + "5f060d5a2aabed06de1ea4552223df7d.pdf";